<template>
  <b-modal
    id="create-user-modal"
    centered
    size="lg"
    hide-footer
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"    
  >
    <template #modal-title> <h2 class="m-0">Create User</h2> </template>
    <validation-observer ref="createUserFormValidation">
      <b-form @submit.prevent>
        <!-- <VueSelectPaginated
          placeholder="Role"
          name="Role"
          label="name"
          rules="required"
          searchBy="name"
          :getListMethod="getRoles"
          @click="hideUsername()"
          @setMethod="
            (value) => {
              role = value;
            }
          "
        /> -->
        <b-form-group label-for="role">
          <template #label>
            Role <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="role"
            placeholder="Select Role"
            :options="roles"
            autoscroll
            :clearable="true"
            required
            @input="hideUsername()"
          ></v-select>
        </b-form-group>
        <b-form-group label-for="username" v-if="!hideusername">
          <template #label>
            Username <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Username"
            :rules="{ required, regex: /^[A-Z0-9]*$/i }"
          >
            <b-form-input
              id="username"
              v-model="username"
              :state="errors.length > 0 ? false : null"
              placeholder="Username"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <!-- <b-form-group label-for="password">
          <template #label>
            Password <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Password"
            rules="required"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                id="password"
                v-model="password"
                :state="errors.length > 0 ? false : null"
                class="form-control-merge"
                :type="passwordFieldType"
                name="password"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="passwordToggleIcon"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group> -->
        <b-form-group label-for="Name">
          <template #label>
            Name <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Name"
            :rules="{ required }"
          >
            <b-form-input
              id="name"
              v-model="name"
              :state="errors.length > 0 ? false : null"
              placeholder="Name"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="mobile_number">
          <template #label>
            Mobile <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Mobile"
            rules="required|integer|mobile-length"
          >
            <b-form-input
              id="mobile_number"
              v-model="mobile_number"
              :state="errors.length > 0 ? false : null"
              placeholder="Mobile"              
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="email">
          <template #label>
            Email <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Email"
            rules="required|email"
          >
            <b-form-input
              id="email"
              v-model="email"
              :state="errors.length > 0 ? false : null"
              placeholder="Email"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        

      </b-form>
    </validation-observer>
    <b-form-group class="text-right">
      <b-button type="submit" variant="primary" pill @click="validationForm">
        Submit
      </b-button>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    extend,
    ValidationObserver,
    VueSelectPaginated,
  },
  mixins: [util, togglePasswordVisibility],
  data() {
    return {
      required,
      username: "",
      password: 'Default@123',
      name: "",
      mobile_number: "",
      email: "",
      role: null,
      roles: [],
      hideusername: false,
    };
  },
  async mounted() {
    const roles = await this.getRolesDDL();
    this.roles = roles.data.results;
  },
  methods: {
    ...mapActions({
      createUser: "appData/createUser",
      getRolesDDL: "appData/getRolesDDL",
    }),
    async validationForm() {
      const success = await this.$refs.createUserFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    hideUsername(){
      if(this.role.code_name == 'rs' || this.role.code_name == 'vs'){        
        this.hideusername = true;
        this.username = this.mobile_number;
      }
      else{
        this.hideusername = false;
      }
    },
    async submit() {    
      if(this.role.code_name == 'rs' || this.role.code_name == 'vs'){        
        this.username = this.mobile_number;
      }  
      try {        
        const res = await this.createUser({
          username: this.username,
          password: this.password,
          name: this.name,
          mobile_number: this.mobile_number,
          email: this.email,
          role: this.role.id,
          initial_reset: false,
          status: 'Admin',
          profile_status: 'Approved',
          created_by: this.getLoggedInUser.id,
          updated_by: this.getLoggedInUser.id,
        });
        if (res.status === 201) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "User Created Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.$nextTick(() => {
            this.$bvModal.hide("create-user-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  created(){
    extend('mobile-length', {
      validate(value) {
        const length = value.replace(/\D/g, '').length; // Remove non-numeric characters and get length
        return length >= 9 && length <= 10;
      },
      message: 'The mobile number must be between 9 and 10 digits.',
    });
  },
  
};
</script>

<style></style>
